(function () {
  'use strict';
  var root = document.querySelector('[data-newsletter-popup]');
  if (!root) return;
  var panel = root.querySelector('.newsletter-popup__panel');
  var form = root.querySelector('[data-newsletter-form]');
  var input = form.querySelector('[name="email"]');
  var submit = form.querySelector('[type="submit"]');
  var error = root.querySelector('[data-newsletter-error]');
  var success = root.querySelector('[data-newsletter-success]');
  var closeButton = root.querySelector('[data-newsletter-close]');
  var contactKey = 'cinta_checkout_contact_v1';
  var stateKey = 'cinta_newsletter_popup_v1';
  var sessionKey = 'cinta_newsletter_session_v1';
  var week = 7 * 24 * 60 * 60 * 1000;
  var shown = false;
  var previousFocus = null;
  var elapsed = 0;
  var scrolled = false;
  var lastTick = Date.now();
  var memoryStorage = { getItem: function () { return null; }, setItem: function () {} };
  function storage(name) { try { return window[name] || memoryStorage; } catch (_) { return memoryStorage; } }
  var local = storage('localStorage');
  var sessionStore = storage('sessionStorage');

  function read(storage, key) {
    try { return JSON.parse(storage.getItem(key) || '{}') || {}; } catch (_) { return {}; }
  }
  function write(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (_) { /* Storage may be unavailable. */ }
  }
  function validEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim()); }
  var session = read(sessionStore, sessionKey);
  elapsed = Math.max(0, Number(session.elapsed) || 0);
  scrolled = session.scrolled === true;

  function saveSession() { write(sessionStore, sessionKey, { elapsed: elapsed, scrolled: scrolled }); }
  function isSuppressed() {
    var state = read(local, stateKey);
    var contact = read(local, contactKey);
    return validEmail(contact.email) || state.subscribed === true || Number(state.dismissedAt || 0) + week > Date.now();
  }
  function busy() {
    var active = document.activeElement;
    var dialogs = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .frete-email-modal[data-open="true"]');
    var otherDialogOpen = Array.prototype.some.call(dialogs, function (element) { return element !== panel && element.getClientRects().length > 0; });
    return otherDialogOpen ||
      document.documentElement.classList.contains('frete-email-modal-open') ||
      !!(active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName));
  }
  function open() {
    if (shown || isSuppressed() || busy() || document.hidden) return;
    shown = true;
    previousFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('newsletter-popup-open');
    document.body.classList.add('newsletter-popup-open');
    input.focus();
  }
  function close() {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('newsletter-popup-open');
    document.body.classList.remove('newsletter-popup-open');
    var state = read(local, stateKey);
    if (!state.subscribed) {
      state.dismissedAt = Date.now();
      write(local, stateKey, state);
    }
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }
  function checkScroll() {
    var scrollable = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    if (scrollable > 0 && window.scrollY / scrollable >= 0.4) {
      scrolled = true;
      saveSession();
    }
  }
  function tick() {
    var now = Date.now();
    if (!document.hidden) elapsed += Math.min(now - lastTick, 1500);
    lastTick = now;
    if (!shown) {
      saveSession();
      if (elapsed >= 30000 && scrolled) open();
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
  document.addEventListener('visibilitychange', function () { lastTick = Date.now(); });
  window.addEventListener('storage', function (event) {
    if ((event.key === contactKey || event.key === stateKey) && isSuppressed() && !root.hidden) close();
  });
  closeButton.addEventListener('click', close);
  window.addEventListener('cinta:contact-saved', function () {
    if (isSuppressed() && !root.hidden && !form.hidden) close();
  });
  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(panel.querySelectorAll('button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), a[href]'), function (element) { return element.offsetParent !== null; });
    if (!focusable.length) { event.preventDefault(); panel.focus(); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var email = input.value.trim().toLowerCase();
    if (!validEmail(email) || !input.checkValidity()) {
      error.textContent = 'Informe um e-mail válido.';
      error.hidden = false;
      input.focus();
      return;
    }
    error.hidden = true;
    submit.disabled = true;
    submit.textContent = 'Cadastrando…';
    fetch(window.MansaIntimaApiBase + '/api/calcular-frete/newsletter.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, consent: true, source: 'modal', website: form.elements.website.value })
    }).then(function (response) {
      return response.json().then(function (data) { if (!response.ok || !data.success) throw new Error(); });
    }).then(function () {
      var contact = read(local, contactKey);
      if (!validEmail(contact.email) || String(contact.email).trim().toLowerCase() === email) {
        write(local, contactKey, { email: email, marketing_authorized: true });
      }
      write(local, stateKey, { subscribed: true });
      form.hidden = true;
      window.dispatchEvent(new Event('cinta:contact-saved'));
      success.hidden = false;
      closeButton.focus();
    }).catch(function () {
      error.textContent = 'Não foi possível concluir o cadastro. Tente novamente.';
      error.hidden = false;
    }).finally(function () {
      submit.disabled = false;
      submit.textContent = 'Quero receber novidades e ofertas';
    });
  });
  checkScroll();
  window.setInterval(tick, 1000);
}());
